/* ================================================================
   Le Félin — Bloc rassurance dynamique
   Injecte sous le bouton d'achat un bloc avec :
   - Date de livraison en français (fenêtre J+4 à J+7)
   - Paiement sécurisé (CB, Visa, Mastercard, PayPal, Apple Pay)
   - Satisfait ou remboursé 30 jours
   - Service client français
   ================================================================ */
(function () {
  'use strict';

  const ICONS = {
    truck: 'https://cdn.shopify.com/s/files/1/0970/1651/2859/files/lefelin-truck.png',
    card: 'https://cdn.shopify.com/s/files/1/0970/1651/2859/files/lefelin-credit-card.png',
    guarantee: 'https://cdn.shopify.com/s/files/1/0970/1651/2859/files/lefelin-guarantee.png',
    returns: 'https://cdn.shopify.com/s/files/1/0970/1651/2859/files/lefelin-returns.png',
    support: 'https://cdn.shopify.com/s/files/1/0970/1651/2859/files/lefelin-support.png',
  };

  function capFirst(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function frenchDate(date) {
    const fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
    return capFirst(fmt.format(date));
  }

  function deliveryWindow() {
    const today = new Date();
    const min = new Date(today); min.setDate(today.getDate() + 4);
    const max = new Date(today); max.setDate(today.getDate() + 7);
    while (min.getDay() === 0 || min.getDay() === 6) min.setDate(min.getDate() + 1);
    while (max.getDay() === 0 || max.getDay() === 6) max.setDate(max.getDate() + 1);
    return `entre le <strong>${frenchDate(min)}</strong> et le <strong>${frenchDate(max)}</strong>`;
  }

  function buildHtml() {
    return `
<div class="lf-trust" data-lf-trust>
  <div class="lf-trust__delivery">
    <span class="lf-trust__delivery-icon"><img src="${ICONS.truck}" alt="" loading="lazy" width="32" height="32"></span>
    <div class="lf-trust__delivery-body">
      <span class="lf-trust__delivery-title">Livraison ${deliveryWindow()}</span>
      <span class="lf-trust__delivery-sub">Expédition sous 24 h · Suivi inclus · Livraison toujours offerte</span>
    </div>
  </div>
  <div class="lf-trust__chips">
    <span class="lf-trust__chip">
      <img src="${ICONS.card}" alt="" loading="lazy" width="18" height="18">
      Paiement sécurisé
    </span>
    <span class="lf-trust__sep" aria-hidden="true"></span>
    <span class="lf-trust__chip">
      <img src="${ICONS.guarantee}" alt="" loading="lazy" width="18" height="18">
      30 j satisfait
    </span>
    <span class="lf-trust__sep" aria-hidden="true"></span>
    <span class="lf-trust__chip">
      <img src="${ICONS.returns}" alt="" loading="lazy" width="18" height="18">
      Retours offerts
    </span>
    <span class="lf-trust__sep" aria-hidden="true"></span>
    <span class="lf-trust__chip">
      <img src="${ICONS.support}" alt="" loading="lazy" width="18" height="18">
      SAV France
    </span>
  </div>
  <div class="lf-trust__pays">Visa · Mastercard · CB · PayPal · Apple Pay · Shop Pay</div>
</div>`;
  }

  function inject() {
    if (document.querySelector('[data-lf-trust]')) return;
    const anchor =
      document.querySelector('.main-product__block-buy_buttons') ||
      document.querySelector('.main-product__block-payment_button') ||
      document.querySelector('.shopify-payment-button') ||
      (document.querySelector('button[name="add"]') || {}).closest?.('.product-form') ||
      document.querySelector('button[name="add"]');
    if (!anchor) return false;
    const wrap = document.createElement('div');
    wrap.innerHTML = buildHtml();
    anchor.parentNode.insertBefore(wrap.firstElementChild, anchor.nextSibling);
    return true;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(() => {
    if (inject()) return;
    let tries = 0;
    const itv = setInterval(() => {
      tries++;
      if (inject() || tries > 30) clearInterval(itv);
    }, 250);
  });

  document.addEventListener('shopify:section:load', () => setTimeout(inject, 50));
  document.addEventListener('shopify:section:reorder', () => setTimeout(inject, 50));
})();
